import { put, takeEvery, select } from 'redux-saga/effects'
import {
    GIFTCARD_HOLD_LOADNG, GIFTCARD_HOLD_SUCCESS, GIFTCARD_HOLD_ERROR,
    GIFTCARD_HOLD_DELETE_LOADNG, GIFTCARD_HOLD_RESET,
    GIFTCARD_HOLD_RECALCULATE_LOADNG
} from "../actions/actionGiftCardHold";

import { SHOPCART_DELETE_GIFTCARD, SHOPCART_UPDATE_GIFTCARD } from '../actions/actionShopCart'
import { postGiftCardHold, deleteGiftCardHold } from 'api';
import { genfunction } from 'helpers'

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to perform giftcardhold, response status: " + response.status + "\"}]}")
    }
}

function* AddGiftCardHold(action) {
    try {
        const events = yield select(state => state.reducerShopCart.events);
        const cashless = yield select(state => state.reducerShopCart.cashless);
        const donation = yield select(state => state.reducerShopCart.donation);
        const membershipPackages = yield select(state => state.reducerShopCart.MembershipPackages);
        const transactionfee = yield select(state => state.reducerTransactionFee);
        const gatickets = yield select(state => state.reducerShopCart.GATickets);
        const orderProducts = yield select(state => state.reducerShopCart.orderProducts);
        const reducerBooking = yield select(state => state.reducerBooking);
        const managemybkng = yield select(state => state.reducerShopCart.managemybooking);
        const giftcards = yield select(state => state.reducerGiftCards);
        const donationProducts = yield select(state => state.reducerShopCart.donationProducts);
        const showTransFee = yield select(state => state.reducerShopCart.showTransactionFee);
        const enteredAmountToPay = yield select(state => state.reducerShopCart.enteredAmountToPay);
        let cashlesstotal = cashless ? cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0) : 0;

        const alreadyexistcashless = cashless.find(item => item.GiftcardNo === action.giftCardNo);
        if (alreadyexistcashless) {
            throw { Errors: [{ ErrorMessage: "This giftcard was already used in cart. Delete that giftcard from cart and try again." }] }
        }

        let isTransFeeApplicable = showTransFee && transactionfee.transactionFee[0] && !transactionfee.transactionFee[0].PriceIsAPercentage ? transactionfee.transactionFee[0] : undefined;
        let totalamount = genfunction.subproducttotal(events, cashless, donation, isTransFeeApplicable, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);

        if (managemybkng && reducerBooking && reducerBooking.booking[0]) {
            totalamount = enteredAmountToPay - cashlesstotal;

            if (isTransFeeApplicable) {
                let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], totalamount, 0);
                totalamount += transFee;

            }
        }

        let GetGiftCardHoldRequest = genfunction.GetGiftCardHoldRequest(action.giftCardNo, totalamount);
        let giftholdresponse = yield fetchAsync(postGiftCardHold, GetGiftCardHoldRequest);
        if (giftholdresponse == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to perform giftcardhold\"}]}"
        else {
            yield put({ type: GIFTCARD_HOLD_SUCCESS, payload: giftholdresponse });
        }
    } catch (e) {
        yield put({ type: GIFTCARD_HOLD_ERROR, error: e });
    }
}

function* DeleteGiftCardHold(action) {
    try {
        let giftholdresponse = yield fetchAsync(deleteGiftCardHold, '/?GiftcardHoldRef=' + action.GiftcardHoldRef);
        if (giftholdresponse == "nocontent") {
            yield put({ type: SHOPCART_DELETE_GIFTCARD, payload: action.GiftcardHoldRef });
            yield put({ type: GIFTCARD_HOLD_RESET, payload: '' });
        }
        else {
            yield put({ type: GIFTCARD_HOLD_ERROR, error: giftholdresponse });
        }
    } catch (e) {
        yield put({ type: GIFTCARD_HOLD_ERROR, error: e });
    }
}

function* RecalculateGiftCardHold(action) {
    try {

        const events = yield select(state => state.reducerShopCart.events);
        const cashless = yield select(state => state.reducerShopCart.cashless);
        const donation = yield select(state => state.reducerShopCart.donation);
        const membershipPackages = yield select(state => state.reducerShopCart.MembershipPackages);
        const transactionfee = yield select(state => state.reducerTransactionFee);
        const gatickets = yield select(state => state.reducerShopCart.GATickets);
        const orderProducts = yield select(state => state.reducerShopCart.orderProducts);
        const reducerBooking = yield select(state => state.reducerBooking);
        const managemybkng = yield select(state => state.reducerShopCart.managemybooking);
        const giftcards = yield select(state => state.reducerGiftCards);
        const donationProducts = yield select(state => state.reducerShopCart.donationProducts);
        const showTransFee = yield select(state => state.reducerShopCart.showTransactionFee);
        const refundType = yield select(state => state.reducerShopCart.refundType);
        const enteredAmountToPay = yield select(state => state.reducerShopCart.enteredAmountToPay);
        let cashlesstotal = cashless ? cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0) : 0;

        let isTransFeeApplicable = showTransFee && transactionfee.transactionFee[0] && !transactionfee.transactionFee[0].PriceIsAPercentage ? transactionfee.transactionFee[0] : undefined;
        let totalamount = genfunction.subproducttotal(events, [], donation, isTransFeeApplicable, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);

        if (managemybkng && reducerBooking && reducerBooking.booking[0]) {
            let totalPaid = 0;

            reducerBooking.booking[0].BookingPayments.forEach(x => {
                totalPaid += x.PaymentAmount;
            })
            if (refundType !== "")
                totalamount -= totalPaid;

            if (refundType === "AdditionalPayment" || (refundType === "" && totalamount > 0)) {
                totalamount = enteredAmountToPay;//- cashlesstotal;

                if (isTransFeeApplicable) {
                    let transFee = genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], totalamount, 0);
                    totalamount += transFee;

                }
            }
        }

        let newcashless = genfunction.RecalculatedCashlessArray(cashless, totalamount);

        const toUpdateCashless = genfunction.GetGiftCardHoldRequestForUpdate(newcashless.filter(x => x.state == 'Update'));
        const toDeleteCashless = newcashless.filter(x => x.state == 'Delete');

        let giftholdresponse = '';
        if (toUpdateCashless.length > 0)
            giftholdresponse = yield fetchAsync(postGiftCardHold, toUpdateCashless);

        if (giftholdresponse == 'nocontent')
            throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to update GiftCardHold\"}]}"
        else {
            if (giftholdresponse != '')
                newcashless = genfunction.UpdateNewGiftCardHoldRef(newcashless, giftholdresponse);

            for (let index = 0; index < toDeleteCashless.length; index++) {
                let cashlessholdresponse = yield fetchAsync(deleteGiftCardHold, '/?GiftcardHoldRef=' + toDeleteCashless[index].GiftcardHoldRef);
                if (cashlessholdresponse != "nocontent")
                    throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to delete GiftCardHold\"}]}"
            }
            yield put({ type: SHOPCART_UPDATE_GIFTCARD, payload: newcashless.filter(x => x.state == 'Remain' || x.state == 'Update') });
            yield put({ type: GIFTCARD_HOLD_RESET, payload: '' });
        }
    } catch (e) {
        yield put({ type: GIFTCARD_HOLD_ERROR, error: e });
    }
}

export const sagaGiftCardHold = [
    takeEvery(GIFTCARD_HOLD_LOADNG, AddGiftCardHold),
    takeEvery(GIFTCARD_HOLD_DELETE_LOADNG, DeleteGiftCardHold),
    takeEvery(GIFTCARD_HOLD_RECALCULATE_LOADNG, RecalculateGiftCardHold)
];



